import { formatDate } from '@/utils/date';

export const getShipmentDefaultFilters = () => ({
  CreatedDateFrom: undefined,
  CreatedDateTo: undefined,
  ShipmentStatus: undefined,
  trailerNumber: undefined,
  ShipmentNo: undefined,
  pageNumber: 1,
  pageSize: 10,
});

export const SaversShipmentColumns = {
  progressing: false,
  success: true,
  error: false,
  data: [
    {
      columnName: 'Trailer Number',
      columnValue: 'trailerNumber',
    },
    {
      columnName: 'Shipment Status',
      columnValue: 'status',
    },
    {
      columnName: 'Origin Location',
      columnValue: 'originLocation',
    },
    {
      columnName: 'Destination Location',
      columnValue: 'destinationLocation',
    },
    {
      columnName: 'ETD',
      columnValue: 'etd',
      render: (text) => formatDate(text),
    },
    {
      columnName: 'ETA',
      columnValue: 'eta',
      render: (text) => formatDate(text),
    },
    {
      columnName: 'Assigned To',
      columnValue: 'trafficCoordinatorName',
    },
  ],
  message: false,
};
